import { styled } from '@fluentui/react';
import { GridFilterBase } from './GridFilter.base';
import { getStyles } from './GridFilter.styles';
import { IGridFilterProps, IGridFilterStyleProps, IGridFilterStyles } from './GridFilter.types';

export const GridFilter = styled<IGridFilterProps, IGridFilterStyleProps, IGridFilterStyles>(GridFilterBase, getStyles, undefined, {
  scope: 'GridFilter',
});
